(ns assemble.component.drawer.view
  (:require ["@mui/material/Grid$default" :as Grid]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/Menu$default" :as Menu]
            ["@mui/material/MenuItem$default" :as MenuItem]
            ["@mui/material/Tab$default" :as Tab]
            ["@mui/material/Tabs$default" :as Tabs]
            ["@mui/material/Tooltip$default" :as Tooltip]
            [common.widgets.drawer :as drawer]
            [common.widgets.inline-edit :as inline-edit]
            [uix.core :as uix :refer [$ defui]]))

(defui actions [{:keys [show-move? show-archive? show-more?
                        on-move on-archive
                        archived? more-options drawer-type-label]}]
  (let [[anchor-el set-anchor-el] (uix/use-state nil)]
    ($ :<>
       (when show-move?
         ($ Tooltip
            {:placement :bottom
             :title (str "Move " drawer-type-label)}
            ($ IconButton
               {:onClick on-move
                :sx #js {:color "grey.20"
                         :borderRadius "6px"
                         :backgroundColor "grey.80"
                         :p 0.5}}
               ($ Icon "drive_file_move"))))
       (when show-archive?
         ($ Tooltip
            {:placement :bottom
             :title (str (if archived? "Unarchive " "Archive ") drawer-type-label)}
            ($ IconButton
               {:onClick on-archive
                :sx #js {:color "grey.20"
                         :borderRadius "6px"
                         :backgroundColor "grey.80"
                         :p 0.5}}
               ($ Icon "inventory_2"))))
       (when show-more?
         ($ :<>
            ($ IconButton
               {:onClick (fn [el]
                           (set-anchor-el (.. el -currentTarget)))
                :sx #js {:color "grey.20"
                         :borderRadius "6px"
                         :backgroundColor "grey.80"
                         :p 0.5}}
               ($ Icon "more_horiz"))
            ($ Menu
               {:anchorEl anchor-el
                :onClose #(set-anchor-el nil)
                :open (boolean anchor-el)}
               (for [option more-options]
                 ($ MenuItem
                    {:key (:title option)
                     :onClick (fn [_e]
                                ((:event-fn option) _e)
                                (set-anchor-el nil))}
                    (:title option)))))))))

(defui drawer
  [{:keys [name drawer-type-label detail-view preview-view open? on-close
           on-rename on-move on-archive archived? show-more? more-options
           allow-editing? allow-rename? show-move? show-archive? show-tabs?]
    :or {show-archive? true show-move? true allow-editing? true allow-rename? true show-tabs? true}}]
  (let [[current-tab-id set-current-tab-id] (uix/use-state :details)]
    ($ drawer/drawer
       (merge {:open? open?
               :on-close on-close
               :actions (when (and allow-editing? (or show-move? show-archive? show-more?))
                          ($ actions
                             {:show-move? show-move?
                              :show-archive? show-archive?
                              :show-more? show-more?
                              :on-move on-move
                              :on-archive on-archive
                              :archived? archived?
                              :more-options more-options
                              :drawer-type-label drawer-type-label}))}
              (if (and name allow-rename?)
                {:label-component ($ inline-edit/inline-edit-text-field
                                     {:text-field-props {:placeholder (str "Enter " drawer-type-label " name")
                                                         :data-testid "nameInput"
                                                         :inputProps #js {:sx #js {:fontSize "xxl"
                                                                                   :fontWeight 500
                                                                                   :py 0.5
                                                                                   :pl 1}}}
                                      :value name
                                      :on-accept on-rename})}
                {:label name}))
       ($ Grid
          {:container true
           :rowSpacing 2
           :direction "column"}
          preview-view
          (when show-tabs?
            ($ Tabs {:value current-tab-id}
               (for [{:keys [id label]} [{:id :details
                                          :label "Details"}]]
                 ($ Tab
                    {:key id
                     :value id
                     :onClick (fn [^js _event]
                                (set-current-tab-id id))
                     :data-testid (str "tab-" id)
                     :label label}))))
          (case current-tab-id
            :details detail-view
            nil)))))
